<script lang="ts">
    import {assets as assetPath} from '$app/paths'
    import { analytics } from '$lib/analytics';
    import { page } from '$app/stores'

    let screenSize : number
    let signupMenuOpen : boolean = false
    let mobileMenuOpen : boolean = false
    let mobileSignupMenuOpen : boolean = false
    let tabletSignUpMenuOpen : boolean = false

    let navbarMinWidth : string
    let tabMinWidth : string
    let menuButtons = [
        {
            id: 'hireDevelopers',
            text: 'Hire developers',
            open: false,
            icon_normal: 'icon_1',
            icon_filled: 'icon_1',
            content: [
                {
                    heading: 'Explore',
                    links: [
                        {
                            text: 'Hire developers on OfferZen',
                            url: 'https://www.offerzen.com/hire-developers',
                            action: 'clicked hire developers on offerzen'
                        },
                        {
                            text: 'Pricing',
                            url: 'https://www.offerzen.com/hire-developers/pricing',
                            action: 'clicked pricing'
                        },
                        {
                            text: 'Product features',
                            url: 'https://www.offerzen.com/hire-developers/product-features',
                            action: 'clicked product features'
                        },
                        {
                            text: 'Product demo',
                            url: 'https://www.offerzen.com/hire-developers/product-video',
                            action: 'clicked product demo'
                        },
                        {
                            text: 'Partner services',
                            url: 'https://www.offerzen.com/partners',
                            action: 'clicked partner services'
                        },
                        {
                            text: 'Case studies',
                            url: 'https://www.offerzen.com/hire-developers/case-studies',
                            action: 'clicked case studies'
                        },
                    ],
                    ctaLink: {
                        img: `${assetPath}/assets/nav/developer_preview_list.svg`,
                        text: 'Developers on OfferZen',
                        description: 'Developers on OfferZen',
                        url: 'https://www.offerzen.com/employers/find-developers',
                        action: 'clicked developers on offerzen'
                    }
                },
                {
                    heading: 'Hiring resources',
                    links: [
                        {
                            text: 'Developer hiring guide',
                            description: 'Your all-in-one, curated guide to hiring developers',
                            img: 'dev-hiring-guide',
                            url: 'https://www.offerzen.com/guides/developer-hiring/',
                            action: 'clicked developer hiring guides'
                        },
                        {
                            text: 'Developer hiring trends in South Africa',
                            description: 'Read the latest hiring trends in this in-depth data report',
                            img: 'menu_icon_2',
                            url: 'https://www.offerzen.com/hire-developers/reports/south-africa',
                            action: 'clicked hiring trends in South Africa'
                        },
                        {
                            text: 'Developer hiring  resources',
                            description: 'Resources to help you win at hiring developers',
                            img: 'dev-hiring-resources',
                            url: 'https://www.offerzen.com/hire-developers/resources/developer-hiring',
                            action: 'clicked developer hiring resources'
                        },
                        {
                            text: 'Developer salary benchmarking report',
                            description: 'Get access to salary insights and trends',
                            img: 'salary-benchmarking',
                            url: 'https://www.offerzen.com/hire-developers/resources/reports/salary-benchmarking',
                            action: 'clicked salary benchmarking report'
                        }
                    ]
                }
            ]
        },
        {
            id: 'findJob',
            text: 'Find a dev job',
            open: false,
            icon_normal: 'icon_2',
            icon_filled: 'icon_2',
            content: [
                {
                    heading: 'Explore',
                    links: [
                        {
                            text: 'Find a software developer job',
                            url: 'https://www.offerzen.com/software-engineer-jobs',
                            action: 'clicked find a software developer job'
                        },
                        {
                            text: 'Developer FAQs',
                            url: 'http://docs.offerzen.com/en/collections/111174-candidate-faq-s',
                            action: 'clicked developer faq'
                        },
                        {
                            text: 'Developer guides',
                            url: 'https://docs.offerzen.com/en/collections/111151-candidate-guides',
                            action: 'clicked developer guides'
                        }
                    ],
                    ctaLink: {
                        img: `${assetPath}/assets/nav/companies_list_icon.svg`,
                        text: 'Companies on OfferZen',
                        description: 'See who\'s hiring on OfferZen',
                        url: 'https://www.offerzen.com/companies/public_list',
                        action: 'clicked companies on offerzen'
                    }
                },
                {
                    heading: 'Developer resources',
                    links: [
                        {
                            text: 'Job search guide',
                            description: 'Go-to source for success in your developer job search',
                            img: 'job-search',
                            url: 'https://www.offerzen.com/guides/developer-job-search/',
                            action: 'clicked job search guide'
                        },
                        {
                            text: 'Job search resources',
                            description: 'Resources to help you find your dream job',
                            img: 'job-search-resources',
                            url: 'https://www.offerzen.com/software-engineer-jobs/resources/job-search',
                            action: 'clicked job search resources'
                        },
                        {
                            text: 'Developer career insights',
                            description: 'Read content from our developer community',
                            img: 'career--insight',
                            url: 'https://www.offerzen.com/blog?tag=tech+career+insights',
                            action: 'clicked developer career insights'
                        }
                    ]
                }
            ]
        },
        {
            id: 'community',
            text: 'Community',
            open: false,
            icon_normal: 'icon_3',
            icon_filled: 'icon_3',
            content: [
                {
                    heading: 'Explore',
                    links: [
                        {
                            text: 'About OfferZen community',
                            url: 'https://www.offerzen.com/community',
                            action: 'clicked about offerzen community'
                        },
                        {
                            text: 'OfferZen swag',
                            url: 'https://www.offerzen.com/community/swag',
                            action: 'clicked offerzen swag'
                        }
                    ],
                    ctaLink: {
                        img: `${assetPath}/assets/nav/typescript.svg`,
                        text: 'TypeScript documentary',
                        description: 'Discover how TypeScript came to be from its heroes',
                        url: 'https://www.offerzen.com/community/typescript-origins-documentary',
                        action: 'clicked typescript documentary'
                    }
                },
                {
                    heading: 'Get involved',
                    links: [
                        {
                            text: 'Events',
                            description: 'See upcoming tech community events',
                            img: 'menu_icon_5',
                            url: 'https://www.offerzen.com/events',
                            action: 'clicked events'
                        },
                        {
                            text: 'Earn rewards',
                            description: 'Discover how to earn swag and rewards for referrals to OfferZen',
                            img: 'earn-rewards',
                            url: 'https://www.offerzen.com/blog/earn-by-helping-companies-grow-their-tech-teams ',
                            action: 'clicked earn rewards'
                        },
                        {
                            text: 'Write a blog article',
                            description: 'Share your experiences with the community',
                            img: 'menu_icon_9',
                            url: 'https://www.offerzen.com/community/source',
                            action: 'clicked write a blog article'
                        }
                    ]
                },
                {
                    heading: 'Resources',
                    links: [
                        {
                            text: 'OfferZen blog',
                            description: 'Read content created by the community for the community',
                            img: 'menu_icon_8',
                            url: 'https://www.offerzen.com/blog',
                            action: 'clicked offerzen blog'
                        },
                        {
                            text: 'SA developer trends',
                            description: 'Access data reports on developer careers',
                            img: 'menu_icon_9',
                            url: 'https://www.offerzen.com/reports/software-developer-south-africa',
                            action: 'clicked sa developer report'
                        },
                        { 
                            text: 'Svelte documentary',
                            description: "Discover the origins of the world's most loved language",
                            img: 'Svelte',
                            url: 'https://www.offerzen.com/community/svelte-origins-documentary',
                            action: 'clicked svelte documentary'
                        },
                        {
                            text: 'Laravel documentary',
                            description: 'Discover the origins of Laravel and the people behind it',
                            img: 'menu_icon_11',
                            url: 'https://www.offerzen.com/community/laravel-origins-documentary',
                            action: 'clicked laravel documentary'
                        }
                    ]
                }
            ]
        },
        {
            id: 'about',
            text: 'About',
            open: false,
            icon_normal: 'icon_4',
            icon_filled: 'icon_4',
            content: [
                {
                    heading: 'Explore',
                    links: [
                        {
                            text: 'Our mission',
                            url: 'https://www.offerzen.com/about',
                            action: 'clicked our mission'
                        },
                        {
                            text: 'FAQs and guides',
                            url: 'http://docs.offerzen.com/en/',
                            action: 'clicked faqs and guides'
                        }
                    ],
                    ctaLink: {
                        img: `${assetPath}/assets/nav/join_team_icon.svg`,
                        text: 'Join our product team',
                        description: 'See whos hiring on OfferZen',
                        url: 'https://www.offerzen.com/za/product-careers',
                        action: 'clicked join our product team'
                    }
                },
                {
                    heading: 'Careers',
                    links: [
                        {
                            text: 'Meet the team',
                            description: 'Meet the people who make OfferZen possible',
                            img: 'menu_icon_12',
                            url: 'https://www.offerzen.com/team',
                            action: 'clicked meet the team'
                        },
                        {
                            text: 'Join the OfferZen team',
                            description: 'See the roles we have available on our team',
                            img: 'menu_icon_13',
                            url: 'https://www.offerzen.com/careers',
                            clicked: 'clicked careers'
                        }
                    ]
                }
            ]
        }
    ]
    const handleMenuClick = (event) => {

        if(signupMenuOpen) signupMenuOpen = false
        menuButtons = menuButtons.map((button) => {
            if(event.target.id === button.id) {
                return {...button, open: !button.open}
            }
            return {...button, open: false}
        })
    }

    const handleSignupMenuClick = () => {

        if(!signupMenuOpen) {
            trackClick('clicked sign up button')
        }

        menuButtons = menuButtons.map((button) => {
            return {...button, open: false}
        })
        signupMenuOpen = !signupMenuOpen
    }

    const handleClickOutside = (event) => {
        menuButtons = menuButtons.map((button) => {
            if(button.open && !event.target.closest('.nav__content__main-list')) {
                return {...button, open: false}
            }
            return button
        })
    }

    const handleMobileSignupMenu = () => {

        if(!signupMenuOpen) {
            trackClick('clicked sign up button')
        }

        mobileSignupMenuOpen = !mobileSignupMenuOpen
    }

    const handleMobileMenu = () => {
        if(tabletSignUpMenuOpen) tabletSignUpMenuOpen = false
        mobileMenuOpen = !mobileMenuOpen
        mobileMenuOpen ? document.body.style.overflow = "hidden" : document.body.removeAttribute('style');
    }

    const handleTabletSignUpMenu = () => {
        if(!tabletSignUpMenuOpen) {
            trackClick('clicked sign up button')
        }

        tabletSignUpMenuOpen = !tabletSignUpMenuOpen
    }

    $ : if(screenSize >= 1025) {
        navbarMinWidth = '623px'
        tabMinWidth = '50%'
    }else if(screenSize >= 845 && screenSize <= 1025){
        navbarMinWidth = '890px'
        tabMinWidth = '50%'
    }else {
        navbarMinWidth = '100%'
        tabMinWidth = '100%'
    }

    $ : if(tabletSignUpMenuOpen){
        mobileMenuOpen = false;
    }

    const trackClick = (action : string) => {
        if(action) {
            analytics.track("Navigation Activity", {
                "action" : action,
                "category": "demand marketing",
                "label": $page.url.pathname,
                "source_detail": "top nav"
            })
        }
    }
</script>

<svelte:window bind:innerWidth={screenSize}  on:click={handleClickOutside}/>
<nav>
    <div class="nav__content" class:nav__content--open={mobileMenuOpen}>
        <div class="nav__content-top">
            <a href="https://www.offerzen.com/" data-sveltekit-reload><img src="{assetPath}/assets/nav/offerzen_logo_white.svg"  alt="White OfferZen logo" class="nav__content__logo"/></a>
            {#if screenSize <= 845}
                <div class="nav__content__tablet-signup__container">
                    <button class="nav__content__tablet-signup" on:click={handleTabletSignUpMenu}>Sign up</button>
                </div>
                <button class="nav__content__button" on:click={handleMobileMenu}>
                    {#if !mobileMenuOpen}
                        <span class="nav__hamburger__line" />
                        <span class="nav__hamburger__line" />
                        <span class="nav__hamburger__line" />
                    {:else}
                        <img src="{assetPath}/assets/closeIcon.svg" alt="close icon" loading="lazy"/>
                    {/if}
                </button>
            {/if}
        </div>
        <ul class="nav__content__main-list">
           {#each menuButtons as button}
            <li class="nav__content__main-list__item">
                <button class="nav__content__main-list__button" id={button.id} class:nav__content__main-list__button--open={button.open} on:click={handleMenuClick}>
                    <img src="{assetPath}/assets/nav/{button.icon_normal}-normal.svg" alt="icon" class="button__icon" class:button__icon--show={!button.open} class:button__icon--hide={button.open} loading="lazy"/>
                    <img src="{assetPath}/assets/nav/{button.icon_filled}-filled.svg" alt="icon" class="button__icon--dark" class:button__icon--hide={!button.open} class:button__icon--show={button.open} loading="lazy"/>
                        {button.text}
                    <div style:background-image="url({assetPath}/assets/cheveron-down.png)" class="button__down-arrow"></div>
                </button>
                <nav
                    class="list-content"
                    class:list-content--open={button.open}
                    style:min-width={button.content[2] && screenSize >= 1025 ? '918px' : navbarMinWidth}
                    style:max-width={button.content[2] && screenSize >= 1025 ? '918px' : navbarMinWidth}
                    id="{button.id}_menuTab"
                >
                    <div class="list-content__tab" style:width={button.content[2] && screenSize >= 1025 ? '35%' : tabMinWidth}>
                        <h4>{button.content[0].heading}</h4>
                        {#each button.content[0].links as link}
                            <a href={link.url} data-sveltekit-reload on:click={() => trackClick(link.action)}>{link.text}</a>
                        {/each}
                        <a class="list-content__tab-cta" href={button.content[0].ctaLink.url} data-sveltekit-reload on:click={() => trackClick(button.content[0].ctaLink.action)}>
                            <img src={button.content[0].ctaLink.img} loading="lazy"/>
                            <div class="cta__content">
                                <span class="cta__content__heading">{button.content[0].ctaLink.text}<img src="{assetPath}/assets/blue-arrow.svg" class="heading-arrow"/></span>
                                <p class="cta__content__description">{button.content[0].ctaLink?.description}</p>
                            </div>
                        </a>
                    </div>
                    <div class="list-content__tab list-content__tab--dark" style:width={button.content[2] && screenSize >= 1025 ? '65%' : tabMinWidth}>
                        <div class="">
                            <h4>{button.content[1].heading}</h4>
                            {#each button.content[1].links as link}
                                <a class="cta__block" href={link.url} data-sveltekit-reload on:click={() => trackClick(link.action)}>
                                    <img src="{assetPath}/assets/nav/{link.img}-normal.svg" class="menu-icon--normal" loading="lazy"/>
                                    <img src="{assetPath}/assets/nav/{link.img}-filled.svg" class="menu-icon--filled" loading="lazy"/>
                                    <div class="cta__block__content">
                                        <p class="content__heading">{link.text}</p>
                                        <p class="content__description">{link.description}</p>
                                    </div>
                                </a>
                            {/each}
                        </div>
                       {#if button.content[2]}
                            <div class="">
                                <h4>{button.content[2].heading}</h4>
                                {#each button.content[2].links as link}
                                <a class="cta__block" href={link.url} data-sveltekit-reload on:click={() => trackClick(link.action)}>
                                        <img src="{assetPath}/assets/nav/{link.img}-normal.svg" class="menu-icon--normal" loading="lazy"/>
                                        <img src="{assetPath}/assets/nav/{link.img}-filled.svg" class="menu-icon--filled" loading="lazy"/>
                                        <div class="cta__block__content">
                                            <p class="content__heading">{link.text}</p>
                                            <p class="content__description">{link.description}</p>
                                        </div>
                                    </a>
                                {/each}
                            </div>
                       {/if}
                    </div>
                </nav>
            </li>
           {/each}
            {#if screenSize <= 845}
                <li class="mobile-ctas">
                    <div class="signup-buttons">
                        <a href="https://www.offerzen.com/users/sign_in" class="signup-buttons__login" data-sveltekit-reload>Log in</a>
                        <button class="signup-buttons__signup" on:click={handleMobileSignupMenu}>Sign up</button>
                        <div class="signup-links" class:signup-links--open={mobileSignupMenuOpen}>
                            <h4>Sign up as a developer or company member</h4>
                            <a href="https://www.offerzen.com/candidate/signup" class="signup-links__link" data-sveltekit-reload on:click={() => trackClick('clicked developer sign up')}>
                                <span class="link__text-grey">I want to</span>
                                <span class="link__text-white">find a developer job</span>
                                <img src="{assetPath}/assets/nav/button-checkmark-lightblue.svg" class="link__checkmark" loading="lazy"/>
                            </a>
                            <a href="https://www.offerzen.com/employers/signup" class="signup-links__link" data-sveltekit-reload on:click={() => trackClick('clicked company sign up')}>
                                <span class="link__text-grey">I want to</span>
                                <span class="link__text-white">hire developers</span>
                                <img src="{assetPath}/assets/nav/button-checkmark-lightblue.svg" class="link__checkmark" loading="lazy"/>
                            </a>
                            <button on:click={handleMobileSignupMenu} class="signup-links__close" style="background-image: url({assetPath}/assets/nav/nav_close_icon.svg)"></button>
                        </div>
                    </div>
                </li>
            {:else}
                <li class="desktop-ctas">
                    <div class="signup-buttons">
                        <div class="signup-button__container">
                            <button class="signup-buttons__signup" on:click={handleSignupMenuClick}>Sign up</button>
                            <div class="content__tab"
                                class:content__tab--open={signupMenuOpen}
                                style:width={'425px'}
                            >
                                <h4>Sign up as a developer or company member</h4>
                                <a href="https://www.offerzen.com/candidate/signup" class="content__tab__link" data-sveltekit-reload on:click={() => trackClick('clicked developer sign up')}>
                                    <span class="link__text-grey">I want to</span>
                                    <span class="link__text-white">find a developer job</span>
                                    <img src="{assetPath}/assets/nav/darkblue_rounded_checkmark.svg" class="link__checkmark" loading="lazy"/>
                                </a>
                                <a href="https://www.offerzen.com/employers/signup" class="content__tab__link" data-sveltekit-reload on:click={() => trackClick('clicked company sign up')}>
                                    <span class="link__text-grey">I want to</span>
                                    <span class="link__text-white">hire developers</span>
                                    <img src="{assetPath}/assets/nav/darkblue_rounded_checkmark.svg" class="link__checkmark" loading="lazy"/>
                                </a>
                                <button on:click={handleSignupMenuClick} class="content__tab__close" style="background-image: url({assetPath}/assets/nav/nav_close_icon.svg)" ></button>
                            </div>
                        </div>
                        <a href="https://www.offerzen.com/users/sign_in" class="signup-buttons__login" data-sveltekit-reload>Log in <img src="{assetPath}/assets/cheveron-down.png" alt="right facing white cheveron arrow"/></a>
                    </div>
                </li>
            {/if}
        </ul>
    </div>
    <div class="content__tab-tablet"
        class:content__tab-tablet--open={tabletSignUpMenuOpen}
        style:width={'425px'}
    >
        <h4>Sign up as a developer or company member</h4>
        <a href="https://www.offerzen.com/candidate/signup" class="content__tab__link" data-sveltekit-reload on:click={() => trackClick('clicked developer sign up')}>
            <span class="link__text-grey">I want to</span>
            <span class="link__text-white">find a developer job</span>
            <img src="{assetPath}/assets/nav/darkblue_rounded_checkmark.svg" class="link__checkmark" loading="lazy"/>
        </a>
        <a href="https://www.offerzen.com/employers/signup" class="content__tab__link" data-sveltekit-reload on:click={() => trackClick('clicked company sign up')}>
            <span class="link__text-grey">I want to</span>
            <span class="link__text-white">hire developers</span>
            <img src="{assetPath}/assets/nav/darkblue_rounded_checkmark.svg" class="link__checkmark" loading="lazy"/>
        </a>
        <button on:click={handleTabletSignUpMenu} class="content__tab__close"  style="background-image: url({assetPath}/assets/nav/nav_close_icon.svg)"></button>
    </div>
</nav>

<style lang="postcss">
    @import '../../styles/_mixins.css';

    nav {
        background-color:var(--color_offerzen_navy);
        display: flex;
        justify-content: center;
        border:solid;
        border-width:0px 0px 1px 0px;
        border-color:rgba(#2f96f4, .2);
        position: fixed;
        z-index:10001;
        width:100%;

        & .nav__content {
            display: flex;
            align-items: center;
            width: 1200px;
            position: relative;
            background-color:var(--color_offerzen_navy);
            padding:0 24px;

            @mixin screen-md {
                width:100%;
                height:75px;
                flex-direction:column;
                align-items:flex-start;
                padding:24px 0 0;
                overflow:hidden;
                transition: height .5s, border-color 1.2s;
                border:solid;
                border-width:0px 0px 1px 0px;
                border-color:rgba(#2f96f4, .2);
            }

            & .nav__content-top {

                @mixin screen-md {
                    width:100%;
                    display:flex;
                    padding:0 24px;

                }

                & .nav__content__tablet-signup__container {
                        position: relative;
                        margin-left:auto;
                    & .nav__content__tablet-signup {
                        display:none;
                        @mixin screen-md {
                                align-items: center;
                                background-color: var(--color_offerzen_cerulean);
                                border: none;
                                border-radius: 3px;
                                color: var(--color_white);
                                display: flex;
                                font-size: 16px;
                                font-weight: 600;
                                height: 35px;
                                margin: 0 15px 0 auto;
                                padding: 5px 13px;
                                text-decoration: none;
                                display:flex;
                        }

                       @mixin screen-sm {
                            display:none;
                       }
                    }
                }

                & .nav__content__button {
                    & .nav__hamburger__line {
                        &::after {
                            content: "";
                            display: block;
                            background-color: var(--color_white);
                            border-radius: 1px;
                            height: 3px;
                            width:18px;
                            margin-bottom:3px;
                        }
                    }

                    & img {
                        height:15px;
                        aspect-ratio: 1;
                    }

                    @mixin screen-md {
                        border:none;
                        background-color:transparent;
                    }

                    @mixin screen-sm {
                        margin-left:auto;
                    }
                }

                & .nav__content__logo {
                    height:30px;
                    @mixin screen-md {
                        height:40px;
                        aspect-ratio:3/1;
                    }
                }
            }

            & .nav__content__main-list {
                display: flex;
                list-style: none;
                gap:32px;
                margin:0;
                position: relative;
                width:100%;

                & .nav__content__main-list__item {

                    transition: all 1s ease-in;

                    & .list-content {
                        background-color: #0e1b43;
                        top:80px;
                        left:42px;
                        z-index: -100;
                        position: absolute;
                        border-radius: 10px;
                        transform-style: preserve-3d;
                        transition: all .2s ease-in;
                        opacity:0;
                        transform: translate3d(0px, -5px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
                        visibility: hidden;
                        overflow: hidden;
                        box-shadow: 4px 4px 20px rgba(11,18,54,.5);

                        @mixin screen-lg {
                            left:-150px;
                        }

                        @mixin screen-md {
                            position: static;
                            top:inherit;
                            left:inherit;
                            flex-direction:column;
                            border-radius:0;
                            height:0%;
                            transition: opacity .2s ease-in;
                        }

                        & .list-content__tab {
                            width:35%;
                            padding:40px 24px;
                            display: flex;
                            flex-direction: column;

                            & h4 {
                                color: #5ea5ee;
                                margin:0;
                                padding:0px 0px 12px 12px;
                                font-size:14px;
                                font-weight:600;

                                @mixin screen-md {
                                    padding:0px 0px 12px 24px;
                                }

                                @mixin screen-sm {
                                    font-size:16px;
                                }
                            }

                            & a {
                                color:var(--color_white);
                                padding:12px 0 12px 12px;
                                transition: all .5s;
                                font-size:16px;
                                text-decoration: none;

                                &:hover {
                                    background-color: rgba(47,150,244,.15);
                                    border-radius: 7px;
                                    text-shadow: .6px 0px var(--color_white);

                                    @mixin screen-md {
                                        border-radius:0px;
                                    }
                                }

                                &:active {
                                    @mixin screen-md {
                                        background-color: rgba(47,150,244,.15);
                                        border-radius:0px;
                                        text-shadow: .6px 0px var(--color_white);
                                    }
                                }

                                @mixin screen-md {
                                    padding:14px 0 12px 24px;
                                }

                                @mixin screen-sm {
                                    font-size:18px;
                                }

                            }

                            & .list-content__tab-cta {
                                display: flex;
                                align-items: flex-start;
                                gap:12px;
                                margin:12px 0 0;
                                padding:13px;
                                background-color: rgba(47,150,244,.15);
                                border-radius: 7px;

                                & img {
                                    height:40px;
                                    aspect-ratio: 1;
                                    @mixin screen-md {
                                        display:none;
                                    }
                                }

                                @mixin screen-md {
                                    /* display:none; */
                                    margin:0;
                                    background-color:transparent;
                                    padding:13px 24px;

                                }

                                & .cta__content {
                                    position: relative;
                                    & .cta__content__heading {
                                        font-size:16px;
                                        color:var(--color_white);
                                        position:relative;

                                        & .heading-arrow {
                                            height:12px;
                                            transition: margin 1s;
                                            position: absolute;
                                            left:105%;
                                            top:10%;
                                        }
                                    }

                                    & .cta__content__description {
                                        margin:4px 0 0px 0;
                                        color:var(--color_grey_secondary);
                                        font-weight: 400;
                                        font-size:14px;
                                        text-shadow: none;
                                        line-height: 20px;

                                        @mixin screen-md  {
                                            display:none;
                                        }
                                    }

                                }

                                &:hover  .heading-arrow {
                                    margin-left:4px;
                                }

                            }

                            @mixin screen-md {
                                background-color:var(--color_offerzen_midnight);
                                padding:40px 0px 12px;
                            }
                        }

                        & .list-content__tab--dark {
                            background-color: var(--color_offerzen_midnight);
                            border-radius: 0 10px 10px 0;
                            display: flex;
                            flex-direction: row;

                            & .cta__block {
                                display: flex;
                                align-items: flex-start;
                                gap:16px;
                                padding:12px;

                                & .cta__block__content {
                                    & p {
                                        margin:0;
                                    }

                                    & .content__heading {
                                        font-size:16px;
                                        margin:0 0 8px;

                                        @mixin screen-md {
                                            margin:0 0 4px;
                                        }
                                    }

                                    & .content__description {
                                        font-size:14px;
                                        color:#a6acaf;
                                        text-shadow: none;
                                        line-height: 150%;

                                        @mixin screen-sm {
                                            font-size:16px;
                                        }
                                    }
                                }

                                & .menu-icon--filled {
                                    display: none;
                                    opacity: 0;
                                    aspect-ratio: 1;
                                    max-height:40px;
                                }

                                & .menu-icon--normal {
                                    aspect-ratio: 1;
                                    max-height:40px;
                                }

                                &:hover .menu-icon--normal {
                                    opacity:0;
                                    display: none;
                                }

                                &:hover .menu-icon--filled {
                                    opacity:1;
                                    display: block;
                                }

                                @mixin screen-md {
                                    gap:12px;
                                    padding: 16px 24px;
                                }
                            }

                            @mixin screen-md {
                                padding:16px 0px 40px;
                                flex-direction:column;
                                gap:40px;
                            }
                        }
                    }

                    & .list-content--open {
                        display: flex;
                        opacity:1;
                        transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
                        visibility: visible;

                        @mixin screen-md {
                            height:100%;
                            z-index:auto;
                            flex-direction:column;
                        }
                    }

                    @mixin screen-md {
                       display:flex;
                       flex-direction:column;
                       align-items:center;
                    }
                }

                & .nav__content__main-list__button {
                    background-color:transparent;
                    height:100%;
                    color: var(--color_offerzen_lightblue);
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 20px;
                    text-decoration: none;
                    display: flex;
                    align-items: center;
                    gap:4px;
                    height:62px;
                    border:solid;
                    border-width: 0 0 2px;
                    border-color: transparent;
                    transition: all .5s;
                    padding:0;

                    &:hover {
                        color:var(--color_white);
                        border-color:#2f96f4;
                        font-weight:600;

                        @mixin screen-lg {
                            border-color:rgba(#2f96f4, .20);
                        }
                    }

                    @mixin screen-md {
                        width:94%;
                        padding:16px 0px;
                        height:inherit;
                        border-color:rgba(#2f96f4, .20);
                    }

                    @mixin screen-sm {
                        width:88%;
                        font-size:18px;
                    }

                    & .button__icon {
                        display: none;

                        @mixin screen-md {
                            display:block;
                            margin-right:12px;
                        }
                    }

                    & .button__icon--dark {
                        display:none;

                        @mixin screen-md {
                            display:none;
                            opacity:0;
                            margin-right:12px;
                            transition: all 1s;
                        }
                    }

                    & .button__icon--show {
                        @mixin screen-md {
                            display: block;
                            opacity: 1;
                        }
                    }

                    & .button__icon--hide {
                        @mixin screen-md {
                            display: none;
                            opacity: 0;
                        }
                    }

                    & .button__down-arrow {
                        width:20px;
                        height:20px;
                        transition: transform .6s;
                        display: block;
                        background-size:cover;
                        pointer-events: none;

                        @mixin screen-md {
                            margin-left:auto;
                        }
                    }
                }

                & .nav__content__main-list__button--open {
                    border-color:var(--color_offerzen_cerulean);
                    font-weight:600;
                    & .button__down-arrow {
                        transform: rotate(180deg);
                    }

                    @mixin screen-md {
                        color:var(--color_white);
                        /* text-shadow: .4px 0px var(--color_white); */
                        border:none;
                    }
                }

                & .mobile-ctas {
                    display: none;

                    @mixin screen-md {
                        display:block;
                        margin-top:auto;
                    }

                    & .signup-buttons {
                        @mixin screen-md {
                            display: flex;
                            justify-content: center;
                            gap:16px;
                            padding: 30px 24px;
                            margin-right:auto;
                            border:solid;
                            border-width:2px 0 0 0;
                            border-color: rgba(47,150,244,.2);
                            position:relative;
                            & a, & button {
                                display: block;
                                padding:13px 24px;
                                border:solid;
                                text-align: center;
                                border-radius:4px;
                                text-decoration:none;

                                @mixin screen-md {
                                    min-width:350px;
                                }

                                @mixin screen-sm {
                                    min-width:170px;
                                }
                            }

                            & .signup-buttons__login {
                                background-color:transparent;
                                color:var(--color_offerzen_cerulean);
                                font-weight:600;
                                font-size:18px;
                            }

                            & .signup-buttons__signup {
                                background-color:var(--color_offerzen_cerulean);
                                color:var(--color_white);
                                border-color:var(--color_offerzen_cerulean);
                                font-weight:600;
                                font-size:18px;
                            }


                            & .signup-links {
                                z-index: 100;
                                color: var(--color_white);
                                background-color: #2c86df;
                                border: 1px solid rgba(47,150,244,.2);
                                padding: 24px;
                                box-shadow: 4px 0 20px rgba(11,18,54,.5);
                                flex-wrap: wrap;
                                gap:0 24px;
                                transition: opacity .5s ease-in, transform .5s ease-in;
                                position:absolute;
                                opacity:0;
                                transform: translate3d(0px, 80px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
                                visibility: hidden;
                                top:-79px;
                                border-radius:0;
                                width:100%;
                                height:0%;
                                overflow:hidden;
                                display:flex;

                                @mixin screen-sm {
                                    flex-direction:column;
                                    gap:24px;
                                }

                                & .signup-links__close {
                                    position: absolute;
                                    z-index: 3;
                                    height:15px;
                                    width:15px;
                                    background-repeat: no-repeat;
                                    background-size: 15px;
                                    left:94%;
                                    top:10%;
                                    background-color: transparent;
                                    border: none;
                                    min-width: 15px;
                                    padding: 0;


                                    @mixin screen-sm {
                                        left:90%;
                                        top:15%;
                                    }
                                }

                                & h4 {
                                    width: 100%;
                                    margin:0 0 24px;
                                    font-weight: 600;
                                    font-size:18px;

                                    @mixin screen-sm {
                                        margin:0;
                                    }
                                }

                                & .signup-links__link {
                                    color:var(--color_white);
                                    border: 2px solid var(--color_white);
                                    border-radius: 7px;
                                    flex: 1;
                                    justify-content: space-between;
                                    align-items: flex-start;
                                    padding: 12px;
                                    font-weight: 500;
                                    text-decoration: none;
                                    display: block;
                                    position: relative;
                                    min-width:0;
                                    text-align:left;

                                    & .link__text-grey{
                                        color:var(--color_grey_secondary);
                                        font-size:16px;
                                        margin:0 0 4px;
                                        display: block;
                                    }

                                    & .link__text-white {
                                        font-size:18px;
                                    }

                                    & .link__checkmark {
                                        position: absolute;
                                        top:10%;
                                        right:5%;
                                        opacity: 0;
                                        height:17px;
                                    }

                                    &:hover {
                                        background-color:var(--color_offerzen_midnight);
                                        border-color:var(--color_offerzen_midnight);
                                        color:var(--color_white);
                                    }

                                    &:hover .link__text-grey {
                                        color:var(--color_grey_secondary);
                                    }

                                    &:hover .link__text-white, &:active .link__text-white {
                                        font-weight:600;
                                    }

                                    &:hover .link__checkmark {
                                        opacity:1;
                                    }
                                }
                            }

                            & .signup-links--open {
                                opacity:1;
                                z-index:100;
                                transform: translate3d(0px, 30px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
                                visibility: visible;
                                height:auto;
                                overflow:visible;

                                @mixin screen-sm {
                                    transform: translate3d(0px, -83px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
                                }
                            }
                        }
                    }
                }

                & .desktop-ctas {
                    margin-left:auto;
                    & .signup-buttons {
                        display: flex;
                        align-items: center;
                        height:100%;
                        gap:0px;

                        & .signup-button__container {
                            position: relative;

                            & .signup-buttons__signup {
                                background-color:var(--color_offerzen_cerulean);
                                color:var(--color_white);
                                border-color:var(--color_offerzen_cerulean);
                                font-weight:600;
                                padding:5px 13px;
                                border-radius: 3px;
                                text-decoration: none;
                                margin:0 15px 0 0px;
                                font-size:16px;
                                height:35px;
                                display: flex;
                                align-items: center;
                                border:none;

                                &:hover {
                                    background-color:#2e71c1 !important;
                                }
                            }

                            & .content__tab {
                                z-index: 2;
                                min-width: 425px;
                                color: var(--color_white);
                                background-color: var(--color_offerzen_midnight);
                                border: 1px solid rgba(47,150,244,.2);
                                border-radius: 10px;
                                margin-top: 35px;
                                padding: 24px;
                                position: absolute;
                                right: -78%;
                                box-shadow: 4px 0 20px rgba(11,18,54,.5);
                                flex-wrap: wrap;
                                gap:0 24px;
                                transition: all .2s ease-in;
                                opacity:0;
                                transform: translate3d(0px, -5px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
                                visibility: hidden;
                                display: flex;

                                & .content__tab__close {
                                    display: block;
                                    position: absolute;
                                    z-index: 3;
                                    height:12px;
                                    width:12px;
                                    background-repeat: no-repeat;
                                    background-size: cover;
                                    left:94%;
                                    top:10%;
                                    background-color: transparent;
                                    border: none;
                                }

                                & h4 {
                                    width: 100%;
                                    margin:0 0 18px;
                                    font-weight: 600;
                                }

                                & .content__tab__link {
                                    color:var(--color_white);
                                    border: 1px solid var(--color_white);
                                    border-radius: 7px;
                                    flex: 1;
                                    justify-content: space-between;
                                    align-items: flex-start;
                                    padding: 12px;
                                    font-weight: 500;
                                    text-decoration: none;
                                    display: block;
                                    position: relative;

                                    & .link__text-grey{
                                        color:#a6acaf;
                                        font-size:14px;
                                        margin:0 0 4px;
                                        display: block;
                                    }

                                    & .link__text-white {
                                        font-size:16px;
                                    }

                                    & .link__checkmark {
                                        position: absolute;
                                        top:10%;
                                        right:5%;
                                        opacity: 0;
                                        height:17px;
                                    }

                                    &:hover {
                                        background-color:var(--color_offerzen_cerulean);
                                        border-color: var(--color_offerzen_cerulean);
                                        color:var(--color_white);
                                    }

                                    &:hover .link__text-grey {
                                        color:var(--color_grey_secondary);
                                    }

                                    &:hover .link__text-white, &:active .link__text-white {
                                        font-weight:600;
                                    }

                                    &:hover .link__checkmark {
                                        opacity:1;
                                    }
                                }
                            }

                            & .content__tab--open {

                                opacity:1;
                                z-index:100;
                                transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
                                visibility: visible;
                            }
                        }

                        & .signup-buttons__signup--open {
                            background-color: #2e71c1;
                        }

                        & .signup-buttons__login {
                            height:100%;
                            display: flex;
                            align-items: center;
                            color:var(--color_grey_secondary);
                            text-decoration: none;
                            font-size:16px;
                            font-weight:600;
                            border:solid;
                            border-width: 0 0 2px;
                            padding: 21px 15px 19px;
                            border-color: transparent;

                            & img {
                                height:12px;
                                transform: rotate(270deg);
                                margin-left:5px;
                                aspect-ratio: 1;
                            }

                            &:hover {
                                border-color: var(--color_offerzen_cerulean);
                                color:var(--color_white);
                            }
                        }

                        @mixin screen-md {
                            display:none;
                        }
                    }
                }

                @mixin screen-lg {
                    gap:24px;
                }
                /*Media queries*/
                @mixin screen-md {
                    background-color:var(--color_offerzen_navy);
                    display:flex; 
                    flex-direction:column;
                    z-index:100;
                    padding:0;
                    left:0;
                    width:100%;
                    gap:0;
                    height:100%;
                    padding:0;
                    margin-top:24px;
                    border:solid;
                    border-width:2px 0 0;
                    border-color: rgba(47,150,244,.2);
                }
            }

            @mixin screen-md {
                width:100%;
            }

        }

        & .nav__content--open {
            @mixin screen-md {
                height:100vh;
                overflow:scroll;
                border-color:transparent;
            }
        }


        & .content__tab-tablet {
            z-index: 999;
            min-width: 425px;
            color: var(--color_white);
            background-color: var(--color_offerzen_midnight);
            border: 1px solid rgba(47,150,244,.2);
            border-radius: 10px;
            padding: 24px;
            position: absolute;
            right:50px;
            box-shadow: 4px 0 20px rgba(11,18,54,.5);
            flex-wrap: wrap;
            gap:0 24px;
            transition: all .2s ease-in;
            opacity:0;
            transform: translate3d(0px, -5px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
            visibility: hidden;
            display: flex;
            top:100px;

            & .content__tab__close {
                display: block;
                position: absolute;
                z-index: 3;
                height:12px;
                width:12px;
                background-repeat: no-repeat;
                background-size: cover;
                left:94%;
                top:10%;
                background-color: transparent;
                border: none;
            }

            & h4 {
                width: 100%;
                margin:0 0 18px;
                font-weight: 600;
            }

            & .content__tab__link {
                color:var(--color_white);
                border: 1px solid var(--color_white);
                border-radius: 7px;
                flex: 1;
                justify-content: space-between;
                align-items: flex-start;
                padding: 12px;
                font-weight: 500;
                text-decoration: none;
                display: block;
                position: relative;

                & .link__text-grey{
                    color:#a6acaf;
                    font-size:14px;
                    margin:0 0 4px;
                    display: block;
                }

                & .link__text-white {
                    font-size:16px;
                }

                & .link__checkmark {
                    position: absolute;
                    top:10%;
                    right:5%;
                    opacity: 0;
                    height:17px;
                }

                &:hover {
                    background-color:var(--color_offerzen_cerulean);
                    border-color: var(--color_offerzen_cerulean);
                    color:var(--color_white);
                }

                &:hover .link__text-grey {
                    color:var(--color_grey_secondary);
                }

                &:hover .link__text-white, &:active .link__text-white {
                    font-weight:600;
                }

                &:hover .link__checkmark {
                    opacity:1;
                }
            }
        }

        & .content__tab-tablet--open {

            opacity:1;
            z-index:100;
            transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
            visibility: visible;
        }
    }
</style>